import styled from 'styled-components';
import Notification from '@components/Notification';

export const ServerNotification = styled(Notification)`
  margin-bottom: ${(props) => props.theme.x2spacePx}px;
`;

export const FieldWrapper = styled.div`
  position: relative;
  margin-bottom: ${(props) => props.theme.x3spacePx}px;
`;
